import {
  eventDispatcher,
  IAlertBanner,
  TOPICS,
} from "@origin-digital/event-dispatcher";

const showNotification =
  (type: IAlertBanner["payload"]["type"]) => (message: string) => {
    eventDispatcher.dispatch({
      payload: {
        message,
        type,
      },
      topic: TOPICS.ALERT_BANNER_OPEN,
    });
  };

export const showErrorNotification = (message: string): void => {
  showNotification("error")(message);
};

export const showInfoNotification = (message: string): void => {
  showNotification("info")(message);
};

export const hideNotification = (): void => {
  eventDispatcher.dispatch({
    payload: {},
    topic: TOPICS.ALERT_BANNER_CLOSE,
  });
};
